import { ToggleControl, PanelRow } from '@wordpress/components';
import { addFilter, removeFilter } from '@wordpress/hooks';
import { dispatch } from '@wordpress/data';
import { __ } from '@wordpress/i18n';

const GlobalFaqs = ( {allData} ) => {
    const { wp_travel_utils_use_global_faq_for_trip: isGlobalFaq, wp_travel_utils_use_trip_faq_for_trip: isTripFaq } = allData.utilities
    const { updateTripData } = dispatch('WPTravel/TripEdit')
    const handleChange = (name, toggle) => (value) => {
        if (toggle) {
            updateTripData({
                ...allData,
                utilities: {
                    ...allData.utilities,
                    [name]: 'yes' === allData.utilities[name] ? 'no' : 'yes'
                }
            })
            return
        }
        updateTripData({
            ...allData,
            utilities: {
                ...allData.utilities,
                [name]: value
            }
        })
    }
    return <>
        <PanelRow>
            <label>{__('Use Global FAQs.', 'wp-travel-pro')}</label>
            <ToggleControl
                // label={'yes' === isGlobalFaq ? __('Use Global FAQs.') : __('Do not use Global FAQs.')}
                help={__('Check to use Global FAQ for the trip.', 'wp-travel-pro')}
                checked={'yes' === isGlobalFaq}
                onChange={handleChange('wp_travel_utils_use_global_faq_for_trip', true)} />
        </PanelRow>
        {'yes' === isGlobalFaq && 
        <PanelRow>
            <label>{__('Use Trip FAQs.', 'wp-travel-pro')}</label>
            <ToggleControl
            // label={'yes' === isTripFaq ? __('Use Trip FAQs.') : __('Do not use Trip FAQs.')}
            help={__('Check to use Trip FAQ along with Global for the trip.', 'wp-travel-pro')}
            checked={'yes' === isTripFaq}
            onChange={handleChange('wp_travel_utils_use_trip_faq_for_trip', true)} />
        </PanelRow>}
    </>
}

const GlobalFaqsCB = ( content, allData ) => {
    return [ ...content, <GlobalFaqs allData={allData} /> ];
}

// Hooks.
removeFilter( 'wptravel_trip_edit_tab_content_faqs', 'WPTravel/TripEdit/FaqsNotice' );
removeFilter( 'wptravel_trip_edit_block_tab_faq', 'WPTravel/TripEdit/Block/FAQ/FaqsNotice' );

addFilter( 'wptravel_trip_edit_tab_content_faqs', 'WPTravelPro\TripEdit\GlobalFaqs', GlobalFaqsCB, 10 );
